import type { Annotation } from '@anaralabs/lector';
import { AnnotationComment } from './annotation-comment';

export interface TooltipContentProps {
  annotation: Annotation;
  onClose: () => void;
}

export const HoverTooltipContent = ({ annotation }: TooltipContentProps) => {
  if (annotation.comment) {
    return <AnnotationComment annotation={annotation} />;
  }
  return null;
};
